import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '@ui/modal/modal.component';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  template: `
    <ui-modal
      [title]="title"
      [submitText]="confirmText"
      [cancelText]="cancelText"
      (close)="onClose()"
      (save)="onConfirm()"
      [variant]="variant">
      <p class="text-slate-600">{{ message }}</p>
    </ui-modal>
  `
})
export class ConfirmModalComponent {
  @Input() title: string = 'Weet u het zeker?';
  @Input() message: string = 'Wilt u doorgaan met deze actie?';
  @Input() onConfirm!: () => void;
  @Input() onClose!: () => void;
  @Input() confirmText: string = 'Ja';
  @Input() cancelText: string = 'Nee';
  @Input() variant: 'primary' | 'danger' | 'success' | 'warning' = 'danger';
}
